module.exports = __webpack_public_path__ + "static/media/terms-zh.6d871682.md";